module.exports = __webpack_public_path__ + "static/media/Quicksand-Medium.365396fd.eot";